const iconMap: Record<string, any> = {
  'arrow-extern': (): any => import('@/assets/svg/icons/arrow-extern.svg'),
  'arrow-header': (): any => import('@/assets/svg/icons/arrow-header.svg'),
  'arrow-right': (): any => import('@/assets/svg/icons/arrow-right.svg'),
  'arrow-left': (): any => import('@/assets/svg/icons/arrow-left.svg'),
  'chevron-down': (): any => import('@/assets/svg/icons/chevron-down.svg'),
  download: (): any => import('@/assets/svg/icons/download.svg'),
  playButton: (): any => import('@/assets/svg/icons/playButton.svg'),
  facebook: (): any => import('@/assets/svg/icons/facebook.svg'),
  instagram: (): any => import('@/assets/svg/icons/instagram.svg'),
  linkedin: (): any => import('@/assets/svg/icons/linkedin.svg'),
  youtube: (): any => import('@/assets/svg/icons/youtube.svg'),
  xing: (): any => import('@/assets/svg/icons/xing.svg'),
  kununu: (): any => import('@/assets/svg/icons/kununu.svg'),
  globe: (): any => import('@/assets/svg/icons/globe.svg'),
  map: (): any => import('@/assets/svg/icons/map.svg'),
  mail: (): any => import('@/assets/svg/icons/mail.svg'),
  phone: (): any => import('@/assets/svg/icons/phone.svg'),
  shapeEven: (): any => import('@/assets/svg/icons/shape-even.svg'),
  shapeWide: (): any => import('@/assets/svg/icons/shape-wide.svg'),
  shapeWideVariant: (): any => import('@/assets/svg/icons/shape-wide-variant.svg'),
  shapeWideVariant2: (): any => import('@/assets/svg/icons/shape-wide-variant2.svg'),
  logo: (): any => import('@/assets/svg/icons/logo.svg'),
  logoExample: (): any => import('@/assets/svg/icons/logo-example.svg'),
  menu: (): any => import('@/assets/svg/icons/menu.svg'),
  minus: (): any => import('@/assets/svg/icons/minus.svg'),
  close: (): any => import('@/assets/svg/icons/close.svg'),
  check: (): any => import('@/assets/svg/icons/check.svg'),
  lineShape: (): any => import('@/assets/svg/icons/line-shape.svg'),
  'logo-baustoffe': (): any => import('@/assets/svg/icons/logos/logo-baustoffe-recycling.svg'),
  'logo-hochundtiefbau': (): any => import('@/assets/svg/icons/logos/logo-hochundtiefbau.svg'),
  'logo-energietechnik': (): any => import('@/assets/svg/icons/logos/logo-energietechnik.svg'),
  'logo-abbruch': (): any => import('@/assets/svg/icons/logos/logo-abbruch.svg'),
  'logo-mineralstoffbehandlung': (): any => import('@/assets/svg/icons/logos/logo-mineralstoffbehandlung.svg'),
  'logo-logistik': (): any => import('@/assets/svg/icons/logos/logo-logistik.svg'),
  'logo-holzsystembau': (): any => import('@/assets/svg/icons/logos/logo-holzsystembau.svg'),
  'logo-bauwerksanierung': (): any => import('@/assets/svg/icons/logos/logo-bauwerksanierung.svg'),
  'logo-beundentkiesung': (): any => import('@/assets/svg/icons/logos/logo-beundentkiesung.svg'),
  'logo-projektentwicklung': (): any => import('@/assets/svg/icons/logos/logo-projektentwicklung.svg'),
  'logo-netzbau': (): any => import('@/assets/svg/icons/logos/logo-netzbau.svg'),
  'logo-kanalsanierung': (): any => import('@/assets/svg/icons/logos/logo-kanalsanierung.svg'),
  'logo-recycling': (): any => import('@/assets/svg/icons/logos/logo-baustoffe-recycling.svg'),
  'logo-schluesselfertigbau': (): any => import('@/assets/svg/icons/logos/logo-schluesselfertigbau.svg'),
  'logo-deponiebau': (): any => import('@/assets/svg/icons/logos/logo-deponiebau.svg'),
  'logo-umwelt': (): any => import('@/assets/svg/icons/logos/logo-umwelt.svg'),
  'logo-umweltsanierung': (): any => import('@/assets/svg/icons/logos/logo-umweltsanierung.svg'),
  'logo-entsorgung': (): any => import('@/assets/svg/icons/logos/logo-entsorgung.svg'),
  'logo-immobilien': (): any => import('@/assets/svg/icons/logos/logo-immobilien.svg'),
  'logo-default': (): any => import('@/assets/svg/icons/logos/logo-default.svg'),
  paper: (): any => import('@/assets/svg/icons/paper.svg'),
};

export default iconMap;
